import { Lookup } from './lookup.interface';

export const FiLegalStatus: { [name: string]: Lookup } = {
  citizen: { displayValue: 'Canadian citizen', code: 'citizen' },
  permanentResident: { displayValue: 'Permanent resident', code: 'permanentResident' },
};
